import React from 'react';
import { motion } from 'framer-motion';

export const Footer: React.FC = () => {
  return (
    <footer className="py-8 px-4 md:px-8 border-t bg-white dark:bg-d-bg-2">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-sawarabi text-l-text-1 dark:text-d-text-1 mb-2">
              光眠
            </h3>
            <p className="text-l-text-3 dark:text-d-text-3">
              あなた仕様の光マットレスで
            </p>
          </div>
          <div className="flex gap-6 text-sm">
            <motion.a
              href="#"
              className="text-l-text-2 dark:text-d-text-2"
              whileHover={{
                color: 'rgb(88 166 255)',
                scale: 1.05,
              }}
              transition={{
                type: 'spring',
                stiffness: 400,
                damping: 25,
                mass: 0.5,
              }}
            >
              プライバシー
            </motion.a>
            <motion.a
              href="#"
              className="text-l-text-2 dark:text-d-text-2"
              whileHover={{
                color: 'rgb(88 166 255)',
                scale: 1.05,
              }}
              transition={{
                type: 'spring',
                stiffness: 400,
                damping: 25,
                mass: 0.5,
              }}
            >
              利用規約
            </motion.a>
            <motion.a
              href="#"
              className="text-l-text-2 dark:text-d-text-2"
              whileHover={{
                color: 'rgb(88 166 255)',
                scale: 1.05,
              }}
              transition={{
                type: 'spring',
                stiffness: 400,
                damping: 25,
                mass: 0.5,
              }}
            >
              サポート
            </motion.a>
            <motion.a
              href="#"
              className="text-l-text-2 dark:text-d-text-2"
              whileHover={{
                color: 'rgb(88 166 255)',
                scale: 1.05,
              }}
              transition={{
                type: 'spring',
                stiffness: 400,
                damping: 25,
                mass: 0.5,
              }}
            >
              お問い合わせ
            </motion.a>
          </div>
        </div>
        <div className="mt-8 pt-4 text-sm border-t border-border-l dark:border-border-d text-center text-l-text-3 dark:text-d-text-3">
          <p>&copy; 2025 光眠. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
